import { AlertSize } from '../../alert/alert';
import { MessageTemplateId } from '../../../common/constants/api-constants';
import { ProductCardData } from '../../product-card/product-card-display';
import { html } from 'lit';
import { shouldConvertFreeTrialForInternational } from './free-trial-conversion.util';
import { MessageType } from '../../alert/global-message.interface';

/**
 * Displays free trial messages for products in the cart list.
 *
 * @param product
 */
export function displayFreeTrialMessages(product: ProductCardData) {
  return html`
    ${displayReplacedFreeTrial(product)}
    ${displayConvertedFreeTrial(product)}
  `;
}

/**
 * Displays an alert message if the free trial product has been replaced.
 *
 * @param product
 */
export function displayReplacedFreeTrial(product: ProductCardData) {
  if (!product?.isFreeTrialReplaced) {
    return html``;
  }

  return html`
    <mhecomm-alert
      id="replaced-free-trial-alert"
      type="${MessageType.warning}"
      size=${AlertSize.small}
      message=${product.title + ' has been updated in your cart.'}
      ?dismissible="${true}">
    </mhecomm-alert>`;
}

/**
 * Displays an alert message if the product has been converted from free trial to purchasable.
 *
 * @param product
 */
export function displayConvertedFreeTrial(product: ProductCardData) {
  if (!product?.isConvertedFromFreeTrial) {
    return html``;
  }

  const messageTemplateId = shouldConvertFreeTrialForInternational()
    ? MessageTemplateId.FREE_TRIAL_INTL_CONVERTED
    : MessageTemplateId.FREE_TRIAL_CONVERTED;

  return html`
    <mhecomm-alert
      id="converted-free-trial-alert"
      type="${MessageType.warning}"
      size=${AlertSize.small}
      message=${messageTemplateId}>
    </mhecomm-alert>`;
}
